<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <div class="input-group">
              <input
                type="text"
                id="search-sources"
                aria-label="SearchSources"
                aria-describedby="SearchSources"
                placeholder="Search sources"
                class="form-control mr-2"
                @input="getSources"
                v-model="searchWord"
              />
            </div>
            <button
              type="button"
              class="ml-auto btn btn-success"
              data-toggle="modal"
              data-target="#exampleModal"
            >
              Add Sources
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="d-flex align-items-center">ID</div>
                  </th>
                  <th scope="col">Description</th>
                  <th scope="col">Candidates</th>
                  <th scope="col">Applications</th>
                  <th style="width:150px">
                    <!-- <a data-toggle="modal" href="#editModal2"><i class="fas fa-pencil-alt"></i></a>
                    <a data-toggle="modal" href="#deleteModal"><i class="fas fa-times"></i></a> -->
                    actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="source in filteredSourceList" :key="source.id">
                  <th scope="row">
                    <div class="d-flex align-items-center">{{ source.source_name }}</div>
                  </th>
                  <td>{{ source.description }}</td>
                  <td>
                    {{ source.candidates_counter }}
                  </td>
                  <td>{{ source.applications_counter }}</td>
                  <td>
                    <button
                      data-toggle="modal"
                      @click="setSourceForUpdate(source)"
                      href="#editModal2"
                      class="btn btn-link"
                    >
                      <svgHelper class="edit" name="edit" />
                    </button>

                    <button
                      class="btn btn-link"
                      data-toggle="modal"
                      @click="setSourceForDelete(source)"
                      href="#deleteModal"
                    >
                      <svgHelper name="delete"></svgHelper>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add Sources</h5>
            <button
              ref="addSourceCloseModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="">
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="source"
                  type="text"
                  class="form-control mb-2"
                  name="source"
                  placeholder="Source ID"
                  id="idsource"
                />
                <label style="text-transform: none!important;" for="idsource">ID</label>
              </div>
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="sourceid"
                  type="text"
                  class="form-control"
                  name="source-id"
                  placeholder="Description"
                  id="sdesc"
                />
                <label for="sdesc">Description</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="addSource" type="button" class="btn btn-primary">Add</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end Main competence modal -->

    <!-- Edit Modal -->
    <div
      class="modal fade edit-modal"
      id="editModal2"
      tabindex="-1"
      aria-labelledby="editModal2"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Edit Source</h5>
            <button
              type="button"
              @click="clearForm"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeEdit"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  disabled
                  type="text"
                  class="form-control"
                  name="source-id"
                  id="id"
                  v-model="updatedSourceId"
                />
                <label for="id">ID</label>
              </div>
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  type="text"
                  class="form-control mt-2"
                  name="source"
                  v-model="updatedSource"
                  id="desc"
                />
                <label for="desc">Description</label>
              </div>
            </div>
          </div>

          <div class="modal-footer text-center justify-content-center">
            <button @click="saveAddSourceChanges" type="button" class="btn btn-primary">
              Edit
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Edit Modal -->
    <!-- Delete Modal -->
    <div
      class="modal fade edit-modal"
      id="deleteModal"
      tabindex="-1"
      aria-labelledby="deleteModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Source</h5>
            <button
              ref="cancelSourceCloseModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>Please confirm that you want to delete source {{ sourceUuidForDeleting.source }}</p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deleteSource()" type="button" class="btn btn-primary">Delete</button>

            <button
              @click="sourceUuidForDeleting = ''"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Delete Modal -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
/* import Pagination from '@/components/Navigations/Pagination'; */
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'Sources | Jobshark';
  },
  components: {
    /*   Pagination, */
  },
  data: () => ({
    isLoading: false,
    currentPage: 1,
    pageCount: 10,
    files: [],
    errorMessage: '',
    sourceid: '',
    source: '',
    sourceUuidForDeleting: {},
    sourceUuidForUpdating: {},
    filteredSourceList: [],
    editSourceid: '',
    editCandidates: 0,
    editApplications: 0,
    updatedSourceId: '',
    updatedSource: '',
    searchWord: '',
  }),
  methods: {
    ...mapActions(['retrieveSourcesList', 'createSource', 'updateSource', 'removeSource']),
    searchSource() {},
    getSources() {
      axios(`${process.env.VUE_APP_API_URL}/admin/source/search`, {
        method: 'post',
        data: {
          search_word: this.searchWord,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.filteredSourceList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addSource() {
      this.isLoading = true;

      this.createSource({ description: this.sourceid, source: this.source })
        .then(() => {
          this.isLoading = false;
          this.$refs.addSourceCloseModal.click();
          this.getSources();
          this.errorMessage = '';
          this.sourceid = '';
          this.source = '';

          this.$toasted.success('You successfully added Source', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          //  this.errorMessage = err.response.data.message;
        });
    },
    setSourceForDelete(source) {
      this.sourceUuidForDeleting = source;
    },
    setSourceForUpdate(source) {
      this.updatedSourceId = source.source_name;
      this.updatedSource = source.description;
      this.sourceUuidForUpdating = source;
    },
    saveAddSourceChanges() {
      this.updateSource({
        id: this.sourceUuidForUpdating.id,
        source: this.updatedSourceId,
        description: this.updatedSource,
      })
        .then(() => {
          this.getSources();
          this.errorMessage = '';
          this.updatedSourceId = '';
          this.updatedSource = '';
          this.$refs.closeEdit.click();
          this.$toasted.success('You successfully updated Source', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    deleteSource() {
      this.isLoading = true;

      this.removeSource({ uuid: this.sourceUuidForDeleting.id })
        .then(() => {
          this.isLoading = false;
          this.getSources();

          this.$refs.cancelSourceCloseModal.click();

          this.$toasted.success('You successfully removed Source', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    clearForm() {
      this.updatedSourceId = '';
      this.updatedSource = '';
    },
    handleFileUpload(e) {
      console.log('handleFileUpload: ', e.target.files[0]);
      /* for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > 20) {
          this.errorMessage = `The file size exceeds the limit of 20 MB.`;
        }
      }

      this.files.push({
        name: this.$refs.file.files[0].name,
        size: this.$refs.file.files[0].size,
      }); */
    },
    toggle(e) {
      e.target.classList.toggle('is-open');
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.currentPage++;
        /* this.retrieveCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          employersList: this.listOfSelectedEmployers.map((item) => item.id),
          optedOut: this.isOptedOut,
          filters: this.selectedFiltersList,
        })
          .then(() => (this.isLoading = false))
          .catch((err) => {
            this.isLoading = false;
            throw err;
          }); */
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;

        /*   this.retrieveCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          employersList: this.listOfSelectedEmployers.map((item) => item.id),
          optedOut: this.isOptedOut,
          filters: this.selectedFiltersList,
        }); */
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      /*  this.retrieveCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        employersList: this.listOfSelectedEmployers.map((item) => item.id),
        optedOut: this.isOptedOut,
        filters: this.selectedFiltersList,
      }); */
    },
    setToFirstPage() {
      this.currentPage = 1;

      /* this.retrieveCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        employersList: this.listOfSelectedEmployers.map((item) => item.id),
        optedOut: this.isOptedOut,
        filters: this.selectedFiltersList,
      }); */
    },
    setToLastPage(lastPage) {
      this.currentPage = lastPage;

      /* this.retrieveCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        employersList: this.listOfSelectedEmployers.map((item) => item.id),
        optedOut: this.isOptedOut,
        filters: this.selectedFiltersList,
      }); */
    },
    hideDeletedSources() {
      this.filteredSourceList = this.getSourceList.filter(sourceObj => sourceObj.status != 2);
    },
  },
  computed: {
    ...mapGetters(['getCurrentPage', 'getTotalPages', 'getSourceList']),
  },
  mounted() {
    this.getSources();
    /*    this.retrieveSourcesList().then(() => {
      this.hideDeletedSources();
    }); */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: left;
            padding-right: 0px;
            a {
              color: #666;
              margin-right: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}

.edit {
  fill: #666;
}
</style>
